export default __webpack_public_path__ + "static/media/FAQs-PT.2826ddf7.jpg";